var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlreadyExist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 124,
    viewBox: "0 0 132 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.403 16.8008C140.71 40.1299 134.072 79.0556 104.578 103.743C91.2321 114.915 75.4918 121.257 60.2831 122.691C41.8834 124.425 24.2617 118.976 12.597 106.204C-8.7092 82.8746 -2.07203 43.9495 27.4217 19.2615C56.9154 -5.42653 98.0964 -6.52818 119.403 16.8008Z",
    fill: "#DAE9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3667 73.7965L78.0026 8.83691L112.458 23.1913L85.8222 88.1506L51.3667 73.7965Z",
    fill: "#2278FF",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00109073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4877 14.8959L55.5317 70.5276C55.8137 70.5397 56.0899 70.599 56.3391 70.7624C57.1252 71.2785 57.3235 72.3888 56.7771 73.2423C56.7551 73.2765 56.7195 73.2925 56.696 73.3251L82.5826 83.6999C82.6342 83.5198 82.6897 83.3412 82.7961 83.1747C83.3167 82.3631 84.3161 82.0963 85.0891 82.5158L107.897 26.7592C107.897 26.7592 106.861 26.6741 106.456 25.8308C106.115 25.1185 106.804 24.231 106.804 24.231L80.8779 13.2031C80.8779 13.2031 81.1811 14.4555 80.3535 15.025C79.4711 15.6325 78.4877 14.8959 78.4877 14.8959Z",
    fill: "#B4D2FE",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00109073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3072 59.9298C71.7584 57.5856 69.1554 51.0756 71.4924 45.3895C73.8294 39.7034 80.2218 36.9944 85.7698 39.3388C91.3186 41.6831 93.9216 48.193 91.5846 53.8791C89.2476 59.5651 82.8552 62.2741 77.3072 59.9298Z",
    fill: "#2278FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1865 57.797C73.7914 55.9385 71.7295 50.7772 73.5809 46.2691C75.4322 41.7609 80.4961 39.613 84.8912 41.4715C89.2855 43.33 91.3481 48.4912 89.496 52.9994C87.6447 57.5076 82.5815 59.6555 78.1865 57.797Z",
    fill: "#FFAB22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2129 50.41L78.3257 44.7461L79.7477 45.2956L79.2096 47.3034C79.2096 47.3034 79.8974 47.1152 80.3807 47.2649L80.9287 46.0306L81.9205 46.497L81.5207 47.6226C81.5207 47.6226 83.5256 48.892 83.1137 50.9475C83.1137 50.9475 86.1788 50.1166 87.5133 50.1794L87.4411 51.7047L82.3583 52.7874L81.1764 52.2495C81.1764 52.2495 82.4958 49.4839 80.8854 48.7644L79.8145 51.5974L78.6996 51.2098L79.9095 48.3109C79.9095 48.3109 77.8879 48.4364 77.7108 50.9684L76.2129 50.41Z",
    fill: "#2278FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1107 91.7008L32.7603 22.9747L69.3407 15.5503L83.691 84.2763L47.1107 91.7008Z",
    fill: "#2278FF",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00109073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5576 27.7209L48.7281 86.6595C48.9681 86.5113 49.2301 86.4057 49.5281 86.4011C50.4683 86.3875 51.255 87.1969 51.2806 88.2092C51.2817 88.2502 51.2615 88.2837 51.2601 88.3232L78.5132 82.4058C78.4554 82.228 78.4015 82.0494 78.3961 81.8518C78.3718 80.8873 79.0497 80.1068 79.9253 80.0202L67.5631 21.0617C67.5631 21.0617 66.6564 21.5721 65.8493 21.1003C65.1674 20.7017 65.2406 19.5806 65.2406 19.5806L37.5886 24.9792C37.5886 24.9792 38.5415 25.8465 38.1756 26.7818C37.7852 27.7796 36.5576 27.7209 36.5576 27.7209Z",
    fill: "#B4D2FE",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00109073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8214 65.6775C54.9126 66.8456 49.1079 62.9133 47.8563 56.8948C46.6047 50.8759 50.3802 45.0496 56.289 43.8813C62.1979 42.713 68.0024 46.6451 69.2541 52.664C70.5058 58.6828 66.7301 64.5093 60.8214 65.6775Z",
    fill: "#2278FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3542 63.4178C55.6727 64.3428 51.0723 61.2238 50.0788 56.4527C49.0852 51.6815 52.0748 47.0645 56.7563 46.1402C61.4377 45.2161 66.0385 48.3347 67.0319 53.1058C68.0252 57.877 65.0356 62.4937 60.3542 63.4178Z",
    fill: "#FFAB22"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5797 58.4071L53.1548 52.5323L54.6401 52.1905L55.3203 54.1547C55.3203 54.1547 55.7838 53.6137 56.2684 53.4664L56.0299 52.1373L57.1132 51.9674L57.413 53.1237C57.413 53.1237 59.7846 53.0514 60.5959 54.9843C60.5959 54.9843 62.6682 52.5785 63.8088 51.8823L64.6037 53.1863L61.0011 56.9318L59.7211 57.1486C59.7211 57.1486 59.2636 54.1187 57.5266 54.4256L58.2274 57.3721L57.087 57.6759L56.4645 54.5967C56.4645 54.5967 54.8603 55.8339 56.1327 58.0301L54.5797 58.4071Z",
    fill: "#2278FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8301 58.3613H92.2905C98.9564 58.3613 104.361 63.5752 104.361 70.0071V107.273C104.361 112.419 100.037 116.59 94.7042 116.59H36.8301V58.3613Z",
    fill: "#1560D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3139 82.4634H104.352V92.4148H86.9012C85.99 92.4148 85.2505 91.7019 85.2505 90.8226V84.4538C85.2505 83.3549 86.1746 82.4634 87.3139 82.4634Z",
    fill: "#438FFE",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00273036,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9736 87.5191C87.9736 86.3731 88.8963 85.4443 90.0332 85.4443C91.171 85.4443 92.0928 86.3731 92.0928 87.5191C92.0928 88.6652 91.171 89.5947 90.0332 89.5947C88.8963 89.5947 87.9736 88.6652 87.9736 87.5191Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.01,
    strokeWidth: 0.00273036,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1588 61.9498C55.3144 61.8515 53.7745 62.6032 53.7745 62.6032C56.0727 75.5011 47.1806 82.142 43.5374 82.8382L43.4146 108.627L69.2218 108.818C75.6917 108.237 75.5724 101.239 75.5724 101.239C80.007 98.5284 76.7998 92.9363 76.7998 92.9363C81.4236 89.9708 77.1775 84.9707 77.1775 84.9707C81.9898 79.8871 76.0451 77.0903 76.0451 77.0903L63.2103 76.9216C64.154 64.6354 60.233 62.1136 57.1588 61.9498Z",
    fill: "#FFBEA6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6107 80.4258H41.8539C42.9557 80.4258 43.8489 81.2823 43.8489 82.3395V108.531C43.8489 109.588 42.9557 110.445 41.8539 110.445H28.6107C27.5089 110.445 26.6157 109.588 26.6157 108.531V82.3395C26.6157 81.2823 27.5089 80.4258 28.6107 80.4258Z",
    fill: "#2278FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyExist);
export default __webpack_public_path__ + "static/media/alreadyExist.18bc74be66fd4d12e6fc997816fda31a.svg";
export { ForwardRef as ReactComponent };